module.exports = __webpack_public_path__ + "img/City of Cape Town.f077b7db.png";